import React from "react";

/**
 * Small inline CSS spinner for buttons. Inherits the button's text color (currentColor),
 * so it shows white on the primary CTA and dark on the SSO buttons.
 */
const Spinner = ({ size = 16 }) => (
    <span className="registration-spinner" role="status" aria-label="Wird geladen" style={{ width: size, height: size }} />
);

export default Spinner;
